<ng-container *ngIf="useEmptyLayout; else mainLayout">
    <router-outlet></router-outlet>
</ng-container>

<ng-template #mainLayout>
    <div class="navigation-menus">
        <router-outlet></router-outlet>
        <navigation></navigation>
        <sera-toast></sera-toast>
        <sera-confirmation-dialog
            [isWithUUID]="true"
            [dialogType]="'CRITICAL'"
            [showtitleIcon]="true"
            [key]="'dialogWithUUID'"
            [title]="'PAGE.SYSTEM_ERROR_GENERIC.LBL'"
            [messageToShow]="'PAGE.OPEN_TICKET_MESSAGE_HELP.LBL'"
            [secondaryButtonLabel]="'PAGE.GENERAL.CLOSE.BT'"
            [primaryButtonLabel]="'PAGE.COPY_CODE_CLIPBOARD.LBL'">
        </sera-confirmation-dialog>
    </div>
</ng-template>
